import { gql } from "apollo-angular";

// Note: used my malfunction-filter component
export const BASE_SUBSCRIPTIONS_OF_TYPE_QUERY = gql`
  query BaseSubscriptionsOfTypeQuery($customer: String!, $products: [String!], $status: [String!]) {
    customer(organisationId: $customer) {
      id: uuid
      subscriptions(productsIncludedFilter: $products, statusFilter: $status) {
        subscriptionId
        customerId
        description
        customerDescriptions {
          customerId
          description
        }
        product {
          type
        }
      }
    }
  }
`;
